/** Ask before a close or back tap drops unsaved typing (PRODUCT.md: never lose work). One wording app-wide. */
export const okToLeave = (dirty: boolean): boolean =>
  !dirty || window.confirm('Leave without saving your changes?');
